import axios from "axios";
import Routes from "./routes";
import Cookies from "js-cookie";


function App() {
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response.status === 401 && !window.location.pathname.startsWith('/login')) {
        document.cookie.split(";").forEach(function (c) {
          document.cookie =
            c.trim().split("=")[0] +
            "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        });
        localStorage.clear();
        Cookies.remove('token')
        window.location.href = "/login"
        // const redirectPath = encodeURIComponent(window.location.pathname + window.location.search)
        // window.location = '/login' + `?redirect=${redirectPath}`;
      }
      return Promise.reject(error);
    }
  );
  return <Routes />;
}

export default App;
